import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _extends from 'babel-runtime/helpers/extends';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { renderRoutes } from 'react-router-routes';

import Split from './Split';

function addSplitComponentsForPaths(routes, splitComponentForPath) {
  if (routes) {
    return routes.map(function (route) {
      if (route.componentPath !== void 0) {
        route = _extends({}, route, {
          component: splitComponentForPath(route.componentPath)
        });
      }
      if (route.routes !== void 0) {
        route = _extends({}, route, {
          routes: addSplitComponentsForPaths(route.routes, splitComponentForPath)
        });
      }
      return route;
    });
  }
}

var SplitRoutes = function (_Component) {
  _inherits(SplitRoutes, _Component);

  function SplitRoutes(props) {
    _classCallCheck(this, SplitRoutes);

    var _this = _possibleConstructorReturn(this, (SplitRoutes.__proto__ || Object.getPrototypeOf(SplitRoutes)).call(this, props));

    _initialiseProps.call(_this);

    _this.routes = addSplitComponentsForPaths(props.routes, _this.splitComponentForPath);
    return _this;
  }

  _createClass(SplitRoutes, [{
    key: 'render',
    value: function render() {
      var routeOptions = this.props.routeOptions;


      return renderRoutes(this.routes, routeOptions);
    }
  }]);

  return SplitRoutes;
}(Component);

SplitRoutes.propTypes = {
  routes: PropTypes.array,
  routeOptions: PropTypes.object,
  loadSplitComponentForPath: PropTypes.func,
  splitErrorCallback: PropTypes.func
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.splitComponentForPath = function (splitComponentPath) {
    var _props = _this2.props,
        loadSplitComponentForPath = _props.loadSplitComponentForPath,
        splitErrorCallback = _props.splitErrorCallback;

    var splitProps = {
      splitComponentPath: splitComponentPath,
      loadSplitComponentForPath: loadSplitComponentForPath,
      splitErrorCallback: splitErrorCallback
    };
    return function (props) {
      return React.createElement(Split, _extends({}, props, splitProps));
    };
  };
};

export default SplitRoutes;